var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.url)?_c('div',{staticStyle:{"height":"100vh","overflow-y":"scroll","-webkit-overflow-scrolling":"touch"}},[_c('iframe',{ref:"iframe",staticStyle:{"height":"100%","width":"100%"},attrs:{"scrolling":"auto","frameborder":"0","id":"iframe"}}),_vm._v(" "),_c('floatBtn')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-071b1062","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mode/gamePage.vue
// module id = null
// module chunks = 